import slice from "../reducer/slice";

import { IState } from '../types/state';

export const updateStations = (stations: IState['stations']['data']) => slice.actions.setStations(stations);
